import { render, staticRenderFns } from "./request-complete.vue?vue&type=template&id=81d7db9a&"
import script from "./request-complete.vue?vue&type=script&lang=js&"
export * from "./request-complete.vue?vue&type=script&lang=js&"
import style0 from "./request-complete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StepsEnd: require('/home/runner/work/myody_front/myody_front/components/steps/StepsEnd.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
